import React, { useEffect, useRef, useState } from "react";
import { useImageStore } from "../../stores/useImageStores";
import "./Bride.css";

const BridalCollections = () => {
  const { imagesByCategory, getImagesByCategory } = useImageStore();
  const images = imagesByCategory.bridal || [];
  const scrollRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  // Fetch bridal images
  useEffect(() => {
  if (!imagesByCategory.bridal) {
    getImagesByCategory("bridal");
  }
}, [getImagesByCategory, imagesByCategory.bridal]);

  // Automatic horizontal scrolling
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer || images.length === 0) return;

    const normalSpeed = 1;
    const hoverSpeed = 0.2;
    let requestId;

    const scrollStep = () => {
      const speed = isHovered ? hoverSpeed : normalSpeed;
      scrollContainer.scrollLeft += speed;

      // Seamless infinite loop
      if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
        scrollContainer.scrollLeft = 0;
      }

      requestId = requestAnimationFrame(scrollStep);
    };

    requestId = requestAnimationFrame(scrollStep);

    return () => cancelAnimationFrame(requestId);
  }, [images, isHovered]);

  return (
    <div className="bridal-collections">
      <h1>BRIDAL COLLECTION</h1>
       <hr />
      <div
        className="collections"
        ref={scrollRef}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {images.length > 0 ? (
          [...images, ...images].map((item, index) => (
            <img
              key={index}
              src={item.image_url}   // ✅ FIXED FIELD
              alt={item.name || "Bridal Image"}
              loading="lazy"
            />
          ))
        ) : (
          <p className="no-images">No bridal images available</p>
        )}
      </div>
    </div>
  );
};

export default BridalCollections;
